import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export default function Audit() {
  const [action, setAction] = useState('');
  const [entityType, setEntityType] = useState('');
  const { data } = useQuery({
    queryKey: ['audit', action, entityType],
    queryFn: () => api(`/api/audit?${action ? `action=${action}&` : ''}${entityType ? `entityType=${entityType}` : ''}`),
  });
  return (
    <>
      <div className="page-header">
        <h1>Audit log</h1>
        <div style={{ display: 'flex', gap: 8 }}>
          <input placeholder="Action filter" value={action} onChange={e => setAction(e.target.value)} />
          <select value={entityType} onChange={e => setEntityType(e.target.value)}>
            <option value="">All entities</option>
            {['User', 'Document', 'Payment', 'Client', 'Article', 'Company', 'VatRate', 'NumberingSeries'].map(x => <option key={x}>{x}</option>)}
          </select>
        </div>
      </div>
      <table className="table">
        <thead><tr><th>Time</th><th>User</th><th>Action</th><th>Entity</th><th>ID</th></tr></thead>
        <tbody>
          {data?.logs?.map(l => (
            <tr key={l.id}>
              <td>{new Date(l.createdAt).toLocaleString()}</td>
              <td>{l.user?.email || '—'}</td>
              <td><code>{l.action}</code></td>
              <td>{l.entityType}</td>
              <td className="muted">{l.entityId?.slice(0, 12) || ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
